const TicketLogoIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={80}
    height={80}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2.75c-.658 0-1.305.212-2.92.764l-.572.196c-1.513.518-2.616.896-3.39 1.21a7 7 0 0 0-.864.404 2 2 0 0 0-.208.139.4.4 0 0 0-.055.05.4.4 0 0 0-.032.074q-.03.082-.063.248a7 7 0 0 0-.1.958c-.046.841-.046 2.015-.046 3.624v1.574c0 5.176 3.87 7.723 6.449 8.849.371.162.586.254.825.315.228.059.506.095.976.095s.748-.036.976-.095c.24-.06.454-.153.825-.315 2.58-1.126 6.449-3.674 6.449-8.849v-1.574c0-1.609 0-2.783-.046-3.624a7 7 0 0 0-.1-.958 2 2 0 0 0-.063-.248.4.4 0 0 0-.032-.074.4.4 0 0 0-.055-.05 2 2 0 0 0-.208-.14 7 7 0 0 0-.864-.402c-.774-.315-1.877-.693-3.39-1.21l-.573-.197C13.305 2.962 12.658 2.75 12 2.75m-3.277-.699c1.444-.494 2.34-.801 3.277-.801s1.833.307 3.277.801l.128.044.599.205c1.481.507 2.625.899 3.443 1.231.412.167.767.33 1.052.495.275.16.55.359.737.626.185.263.281.587.341.9.063.324.1.713.125 1.16.048.886.048 2.102.048 3.678v1.601c0 6.101-4.608 9.026-7.348 10.224l-.027.011c-.34.149-.66.288-1.027.382-.387.1-.799.142-1.348.142-.55 0-.96-.042-1.348-.142-.367-.094-.687-.233-1.027-.382l-.027-.011C6.858 21.017 2.25 18.092 2.25 11.99v-1.6c0-1.576 0-2.792.048-3.679.025-.446.062-.835.125-1.16.06-.312.156-.636.34-.9.188-.266.463-.465.738-.625.285-.165.64-.328 1.052-.495.818-.332 1.962-.724 3.443-1.23l.599-.206z"
      fill="#c2c2c2ff"
    />
  </svg>
);
export default TicketLogoIcon;
